<mat-tab-group #tabs mat-align-tabs="center" animationDuration="0ms">
  <mat-tab [label]="'label.user.account.tabs.personal-informations' | translate">
    <ng-template matTabContent>
      <neq-user-properties [user]="currentUser"></neq-user-properties>
    </ng-template>
  </mat-tab>
  <mat-tab [label]="'label.user.account.tabs.preferences' | translate">
    <ng-template matTabContent>
      <neq-user-preferences [user]="currentUser"></neq-user-preferences>
    </ng-template>
  </mat-tab>
</mat-tab-group>
